"use strict";

exports.__esModule = true;
exports["default"] = LoadingDark;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function LoadingDark(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: "uil-default",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    className: "bk",
    d: "M0 0h100v100H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "translate(0 -30)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(30 105.98 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.08333333333333333s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(60 75.98 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.16666666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(90 65 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.25s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(120 58.66 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.3333333333333333s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(150 54.02 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.4166666666666667s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(180 50 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.5s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(-150 45.98 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.5833333333333334s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(-120 41.34 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.6666666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(-90 35 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.75s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(-60 24.02 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.8333333333333334s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    height: 20,
    rx: 5,
    ry: 5,
    transform: "rotate(-30 -5.98 65)",
    width: 7,
    x: "46.5",
    y: 40
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "opacity",
    begin: "0.9166666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  })));
}